import React, { useEffect } from "react";
import Layout from "../../../components/layouts/Layout";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import PointsSettingsForm, { PointsSettingsFormData } from "../../../components/admin/pointsSettings/PointsSettingsForm";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../../components/form/LoadingButton";
import { useLoyaltySettingsByAdmin } from "../../../hooks/admin/loyaltySettings";
import LoadingErrorState from "../../../components/ui/LoadingErrorState";


export default function PointsSystemAdminPage() {
  const { t } = useTranslation();
  const {data,isLoading , isError} = useLoyaltySettingsByAdmin()

  // Setup React Hook Form
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<PointsSettingsFormData>({
    defaultValues: {
      pointsPerRiyal: 0,
      riyalValue: 0,
      inviteFriendPoints: 0,
    },
  });

  useEffect(()=>{
    if(data){
      setValue("inviteFriendPoints",data.pointsPerInviteAcceptance);
      setValue("pointsPerRiyal",data.pointsPerCurrency);
      setValue("riyalValue",data.currencyPerPoint);
    }
  },[data,setValue]);

    const {loading,updateResource} = useUpdateResource();
          
    const onSubmit = async(data: PointsSettingsFormData) => {
    await updateResource(`loyalty-setting`, 
        {pointsPerCurrency:data.pointsPerRiyal,currencyPerPoint:data.riyalValue,pointsPerInviteAcceptance:data.inviteFriendPoints},
        "admin",{
            method: "POST",
            successMessage: t("updatedSuccess"),
            invalidateQueries: ["loyalty-setting-by-admin"],
            });
    };


  return (
    <Layout title={t("admin_sidebar.points")} headline="">
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {
        data &&
        <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow">
        <form onSubmit={handleSubmit(onSubmit)}>
          <PointsSettingsForm
            register={register}
            errors={errors}
            onSave={handleSubmit(onSubmit)}
          />
          <div className=" mt-6">
            {
              loading
              ?
              <LoadingButton/>
              :
              <SubmitButton label="update"/>
            }
          </div>
        </form>
      </div>
      }
    </Layout>
  );
}
